import React, { useEffect } from "react";

import KitHistoryTimeline from "./kitHistoryTimeline";

export interface KitHistoryModalProps {
	campusId: number;
	kitId: number;
	title?: string;
	subtitle?: string;
	onClose: () => void;
}

/** Overlay with the read-only bitácora of one kit (kits overhaul, Sep 2026). */
const KitHistoryModal: React.FC<KitHistoryModalProps> = ({ campusId, kitId, title, subtitle, onClose }) => {
	useEffect(() => {
		const onKey = (event: KeyboardEvent) => { if (event.key === "Escape") onClose(); };
		window.addEventListener("keydown", onKey);
		return () => window.removeEventListener("keydown", onKey);
	}, [onClose]);

	return <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.45)", zIndex: 2000, display: "flex", alignItems: "center", justifyContent: "center", padding: "16px" }}
		onMouseDown={(event) => { if (event.target === event.currentTarget) onClose(); }}
	>
		<div className="card" style={{ width: "100%", maxWidth: "720px", maxHeight: "85vh", display: "flex", flexDirection: "column", boxShadow: "0 10px 40px rgba(0,0,0,0.25)" }} role="dialog" aria-modal="true">
			<div className="card-body" style={{ overflowY: "auto" }}>
				<div style={{ display: "flex", alignItems: "flex-start", gap: "10px" }}>
					<div style={{ flex: 1 }}>
						<h4 style={{ marginBottom: "2px" }}>{title || "Historial del kit"}</h4>
						{subtitle ? <div style={{ color: "var(--wa-apagado)", fontSize: "13px" }}>{subtitle}</div> : null}
					</div>
					<button type="button" className="btn btn-outline-secondary rounded-pill btn-sm" onClick={onClose}>Cerrar</button>
				</div>
				<hr />
				<KitHistoryTimeline campusId={campusId} kitId={kitId} />
			</div>
		</div>
	</div>;
};

export default KitHistoryModal;
